import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import {
  Devices,
  FileReport,
  History,
  Home,
  LetterB,
  LetterM,
  Link,
  ReceiptRefund,
  ReportMoney,
  Users,
} from 'tabler-icons-react';
import { NavLinkType } from '../../type/navlink.types';
import AppHeader from './header/header.component';
import AppSidebar from './sidebar/sidebar.component';

const ResellerDashboardLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const navLinkProps: NavLinkType[] = [
    {
      order: 1,
      link: '/reseller/dashboard',
      label: 'Dashboard',
      icon: Home,
    },

    {
      order: 2,
      link: '/reseller/merchants',
      label: 'Merchants',
      icon: LetterM,
    },
    {
      order: 3,
      link: '/reseller/branches',
      label: 'Branches',
      icon: LetterB,
    },
    {
      order: 4,
      link: '/reseller/create-payment-links',
      label: 'Payment Links',
      icon: Link,
    },
    {
      order: 5,
      link: '/reseller/transactions',
      label: 'Transactions',
      icon: FileReport,
    },
    {
      order: 6,
      link: '/reseller/refund',
      label: 'Refund Approval',
      icon: ReceiptRefund,
    },
    {
      order: 7,
      link: '/reseller/logs',
      label: 'Logs',
      icon: History,
    },
    {
      order: 8,
      link: '/reseller/settlements',
      label: 'Settlements',
      icon: ReportMoney,
    },
    {
      order: 9,
      link: '/reseller/users',
      label: 'User Management',
      icon: Users,
    },
    {
      order: 10,
      sublinks: [
        { link: 'reseller/pos', label: 'View All POSs' },
        {
          link: '/reseller/pos/create',
          label: 'Create POS',
        },
      ],
      link: '',
      label: 'POS',
      icon: Devices,
    },
  ];

  return (
    <>
      <Helmet>
        <title>XPAY.World - Reseller Dashboard</title>
      </Helmet>
      ;
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <AppShell
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
              '@media (max-width: 992px)': {
                paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
              },
            },
          }}
          navbarOffsetBreakpoint='md'
          asideOffsetBreakpoint='md'
          fixed
          navbar={<AppSidebar navLinkProps={navLinkProps} opened={opened} />}
          header={<AppHeader opened={opened} setOpened={setOpened} />}
        >
          <Outlet />
        </AppShell>
      </MantineProvider>
    </>
  );
};

export default ResellerDashboardLayout;
